<template>
<body>
  <div class="orderDetail" v-if="!isInit">
    <div class="call_agent call_agent_header">
      <div class="order_detail_text">订单详情</div>
      <div class="customer_service_information">
        <span>销售客服</span>
        <img :src="userInfo.photo_url" alt="销售客服头像" class="server_avatar">
        <em>{{userInfo.customer_service_name ? userInfo.customer_service_name :userInfo.name}}</em>
        <a :href="'tel:' + userInfo.cell">
          <img alt="电话号码" class="user-tel" src="~@/assets/images/html/call_03.png">
          <span>{{userInfo.cell}}</span>
        </a>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="orde_info">
      <div class="product_name">
        <em>产品名称：</em>
        <i>{{planInfo.route_plan_name}}</i>
      </div>
      <div class="product_text_color">
        <span class="order_left_width">
          <em>订单编号：</em>
          <i>{{orderId}}</i>
        </span>
        <span v-if="isVisa">
          <em>产品信息：</em>
          <i>
            <a
              @click="$pushByName('visaRouteInfo',{route_id:planInfo.route_id})"
              href="javascript:void(0);"
            >点击查看产品详情</a>
          </i>
        </span>
      </div>
      <!-- <span> <em>出行日期</em> <i>{{orderNote.speciality.travel_date }}</i> </span> -->
      <div>
        <span class="order_left_width">
          <em>出行日期：</em>
          <i>{{isVisa ? orderNote.speciality.travel_date : $dateUtil.df(orderInfo.depart_time)}}</i>
        </span>
        <span>
          <em>报名时间：</em>
          <i>{{$dateUtil.df(orderInfo.add_time)}}</i>
        </span>
      </div>
      <div v-if="isRoute">
        <span>
          <em>团队信息：</em>
          <i>
            <a href="javascript:void(0);">点击查看团队详情</a>
          </i>
        </span>
      </div>
      <div v-if="isVisa">
        <span class="order_left_width">
          <em>资料返还方式：</em>
          <i>{{orderNote.pickup2.pickup2_type_name}}</i>
        </span>
        <span>
          <em>联系人：</em>
          <i>{{orderNote.pickup2.pickup2_customer}}</i>
        </span>
      </div>
      <div>
        <span class="order_left_width">
          <em>联系电话：</em>
          <i>{{orderNote.pickup2.pickup2_tel}}</i>
        </span>
        <span v-if="orderNote.pickup2.pickup2_type == 0">
          <em>领取门店：</em>
          <i>{{agent_name}}</i>
        </span>
        <span v-else>
          <em>收件地址：</em>
          <i>{{orderNote.pickup2.pickup2_address}}</i>
        </span>
      </div>
    </div>
    <div
      class="diylist_num_line diylist_order_detail"
      id="order-detail-pay"
      v-if="orderInfo.order_type != 9 && $number.subtract(orderInfo.total_amount,paidAmount) > 0"
    >
      <a @click="$pushByName('payOrder', {order_id: orderId})" href="javascript:void(0);">
        <span class="des_cancel">立即支付</span>
      </a>
      <!-- TODO 发票模块 order_invoice_inc.jsp -->
    </div>
    <!-- 联系人信息 -->
    <div class="order_contact_info">
      <p class="order_bottom_line">联系人信息</p>
      <p class="order_contact_info_text">
        <span>
          联系人姓名：
          {{orderInfo.contact_person}}
        </span>
        <span>
          手机：
          {{orderInfo.contact_tel}}
        </span>
        <!-- <span>
          固话：
          {{orderInfo.contact_tel2}}
        </span>-->
        <span>
          邮箱：
          {{orderInfo.email}}
        </span>
      </p>
      <p class="order_contact_info_text">
        <span v-show="isRoute">
          上车点：
          {{orderInfo.leave_station}} {{orderInfo.leave_time}}
        </span>
        <span>
          订单备注：
          {{orderInfo.remark}}
        </span>
      </p>
    </div>
    <div class="orde_list">
      <div class="orde_list_bottom">
        <div class="orde_customer_info">
          <div class="travel_person">
            <div class="travel_person_title">
              <p class="order_bottom_line" v-if="isVisa">办签人信息</p>
              <p v-else>出行人信息</p>
            </div>
            <div style=" display: inline-block; border-bottom: 1px solid #ededed; width: 100%;">
              <div v-for="(nameListInfo, index) in nameListInfoList">
                <div class="travel_person_line travel_person_sf">
                  <span>
                    {{nameListInfo.ticket_type}}:
                    {{nameListInfo.name}}
                  </span>
                  <span>
                    所属类型：
                    {{nameListInfo.orderVisaInfo.person_type}}
                  </span>
                </div>
                <div class="travel_person_line" v-if="nameListInfo.credentials_type == '身份证' ">
                  <span>
                    身份证：
                    {{nameListInfo.id_card_no}}
                  </span>
                  
                  <span>
                    预约面试时间:
                    {{nameListInfo.orderVisaInfo.consular_district}}
                  </span>
                  <span
                    tyle="color: #1B83E4; padding-left: 1em;"
                  >{{$dateUtil.df(nameListInfo.orderVisaInfo.interview_date)}}</span>
                </div>
                <div v-if="isVisa">
                  <div class="travel_person_line">
                    <span>
                      护照:
                      {{nameListInfo.passport_no}}
                    </span>
                    <span>
                      预约面试时间:
                      {{nameListInfo.orderVisaInfo.consular_district}}
                    </span>
                    <span
                      style="color: #1B83E4; padding-left: 1em;"
                    >{{$dateUtil.df(nameListInfo.orderVisaInfo.interview_date)}}</span>
                  </div>
                  <div class="travel_person_line">
                    <span>
                      签证办理进度:
                      {{nameListInfo.orderVisaInfo.visa_status}}
                    </span>
                  </div>
                  <div
                    class="diylist_num_line diylist_order_detail"
                    id="order-detail-pay"
                    v-if="$number.subtract(orderInfo.total_amount,paidAmount) == 0 && orderInfo.order_type != 9"
                  >
                    <a
                      @click="pushToUpload(nameListInfo.orderVisaInfo.upload_batch,nameListInfo.name,nameListInfo.name_list_info_id,
                          planInfo.route_plan_id,nameListInfo.person_type,nameListInfo.orderVisaInfo.person_type)"
                      href="javascript:void(0);"
                    >
                      <span
                        class="des_cancel"
                      >{{nameListInfo.orderVisaInfo.upload_batch == 0 ? '上传资料' : '审核进度'}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="orde_price_info">
          <!-- TODO 价格信息 -->
          <div v-if="orderNums != undefined ">
            <table>
              <thead>
                <tr>
                  <th>价格种类</th>
                  <th>单价</th>
                  <th>订购</th>
                  <th>应收金额</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(orderNum, index) in orderNums" v-if="ticketType[index] != '' ">
                  <td>{{ticketType[index]}}</td>
                  <td>{{ticketPrices[index] | currMoney }}</td>
                  <td>{{orderNum}}</td>
                  <td>{{ticketPrices[index] | multiply(orderNum) | currMoney}}</td>
                </tr>
                <!-- TODO 可选项 -->
                <tr :key="index+3" v-for="(orderAdditionalCost, index) in orderAdditionalCosts">
                  <td>{{orderAdditionalCost.additional_cost_name}}</td>
                  <td>{{orderAdditionalCost.price | currMoney}}</td>
                  <td>{{orderAdditionalCost.num}}</td>
                  <td>{{orderAdditionalCost.price | multiply(orderAdditionalCost.num) | money | currency}}</td>
                </tr>

                <!-- TODO 人数优惠 -->
                <tr v-for="(favorableInfo, index) in favorableList">
                  <td>{{favorableInfo.ticket_type}}优惠</td>
                  <td>{{favorableInfo.price | currMoney}}</td>
                  <td>{{favorableInfo.num}}</td>
                  <td>{{favorableInfo.price | multiply(favorableInfo.num) | currMoney}}</td>
                </tr>

                <!-- TODO 提前优惠 -->
                <tr v-for="(advanceInfo, index) in advanceList">
                  <td>{{advanceInfo.ticket_type}}优惠</td>
                  <td>{{advanceInfo.price | currMoney}}</td>
                  <td>{{advanceInfo.num}}</td>
                  <td>{{advanceInfo.price | multiply(advanceInfo.num) | currMoney}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="orde_total">
            <p>
              <em>订单金额&nbsp;&nbsp;</em>
              <i>{{orderInfo.total_amount | money | currency}}</i>
            </p>
          </div>
        </div>
        <!-- 收款信息 -->
        <div class="orde_charge">
          <p class="order_bottom_line">收款信息</p>
          <span>
            应收金额
            <i>{{orderInfo.total_amount | currMoney}}</i>
          </span>
          <span v-if="dingjin != 0">
            定金
            <i>{{dingjin | money | currency}}</i>
          </span>
          <span>
            已支付
            <i>{{paidAmount | money | currency}}</i>
          </span>
          <span>
            未支付
            <i>{{orderInfo.total_amount | subtract(paidAmount) | money | currency}}</i>
          </span>
        </div>
      </div>
    </div>
    <div class="back_order_list">
      <a @click="$router.go(-1)" href="javascript:void(0);" style="color: white;">
        <span>返回</span>
      </a>
    </div>
    <!-- 弹窗、模态框部分 -->
    <el-dialog
      :title="show_upload ? '上传资料' : '审核进度'"
      :visible.sync="dateUploadDialogVisible"
      @close="closeDialog()"
      center
    >
      <data-parent :is_upload="show_upload" :params="upload_params" v-if="dateUploadDialogVisible"></data-parent>
    </el-dialog>
  </div>
</body>
</template>
<script>
import DataParent from '@/pages/customer/p_center/dataParent.vue'
export default {
  name: "OrderDetail",
  componentName: 'OrderDetail',
  components: {
    DataParent
  },
  data () {
    return {
      isInit: true,
      dateUploadDialogVisible: false,
      column: "0", // 默认0  0:出行人信息  1：价格信息  2：收款信息
      orderId: "",
      dingjin: "",
      paidAmount: 0,
      orderInfo: {},
      planInfo: {},
      userInfo: {},
      orderNote: {},
      nameListColumn: {},
      nameListInfoList: {},
      orderNums: [],
      ticketType: [],
      ticketPrices: [],
      orderAdditionalCosts: [],
      advanceList: [],
      favorableList: [],
      agent_name: "",

      upload_params: {},
      show_upload: true
    };
  },
  created () {
    this.orderId = this.$route.query.order_id;
    if (this.orderId == undefined) {
      this.$msg("订单号异常", "error");
      return;
    }
    this.getOrderDetail();
    this.$on('close.dialog.reload', this.setReload)
  },
  computed: {
    isVisa () {
      return this.orderInfo.product_category == 10;
    },
    isRoute () {
      return this.orderInfo.product_category == 0;
    },
    getStyle () {
      if (this.column == "1") {
        return "left: 33.3333%";
      } else if (this.column == "2") {
        return "left: 66.6666%";
      }
    }
  },
  filters: {},
  methods: {
    setReload (is_reload) {
      this.is_reload = is_reload
    },
    closeDialog () {
      if (this.is_reload) {
        this.$store.dispatch('reloadCommonView')
        this.is_reload = false
      }
    },
    getOrderDetail () {
      // 获取订单信息
      const url = "order_info/order_detail/" + this.orderId;
      const params = {};
      var details = this.$myGet(url, params);
      details
        .then(res => {
          console.log(res.response.data.userInfo, "用户的信息的");
          this.orderInfo = res.response.data.orderInfo;
          this.planInfo = res.response.data.planInfo;
          this.userInfo = res.response.data.userInfo;
          this.nameListColumn = res.response.data.nameListColumn;
          this.nameListInfoList = res.response.data.nameListInfoList;
          this.orderNums = res.response.data.orderNums;
          this.ticketType = res.response.data.ticketTypes;
          this.ticketPrices = res.response.data.ticketPrices;
          this.orderAdditionalCosts = res.response.data.orderAdditionalCosts;
          this.advanceList = res.response.data.advanceList;
          this.favorableList = res.response.data.favorableList;
          this.dingjin = res.response.data.dingjin;
          this.paidAmount = res.response.data.paidAmount;
          var note = this.orderInfo.order_note;
          this.orderNote = JSON.parse(note);
          this.agent_name = res.response.data.agent_name;
          this.isInit = false
        })
        .catch(err => {
          console.log("err:" + err);
        });
    },
    // 上传资料 跳转   如果已经提交过资料了，就跳到资料审核页，如何未提交，跳转到上传资料页
    pushToUpload (isUpload, name, nameListId, planId, type, typeName) {
      this.upload_params.order_id = this.orderId
      this.upload_params.name = name
      this.upload_params.name_list_info_id = nameListId
      this.upload_params.plan_id = planId
      this.upload_params.type = type
      this.upload_params.type_name = typeName
      this.show_upload = isUpload == "0"
      this.dateUploadDialogVisible = true
    },
    selectColumn (value) {
      this.column = value;
    }
  }
};
</script>
<style scoped>
@import '../../../assets/css/pages/customer/css.css';
.orderDetail {
  width: 96%;
  margin: 0 auto;
}
.order_detail_text {
  font-size: 26px;
  color: #6f6a6a;
  margin-top: 25px;
}
.customer_service_information {
  text-align: right;
}
.user-tel {
  width: 20px;
  height: 20px;
}
.server_avatar {
  width: 23px;
  height: 23px;
  border-radius: 50%;
}
.display {
  display: none;
}
.upload_div {
  color: #ff6000;
  border: 1px solid #ff6000;
  border-radius: 0.2em;
  text-align: center;
  padding: 2% 1%;
  margin-right: 2%;
  min-width: 20%;
  float: right;
}
.orde_list_top {
  border-top: 0;
}
.product_name em,
.product_name i {
  font-size: 17px;
  color: #898989;
}
.order_left_width {
  display: inline-block;
  width: 50%;
}
.order_contact_info {
  margin-top: 2%;
}
.order_bottom_line {
  font-size: 15px;
  font-weight: bold;
  color: #6f6a6a;
  border-bottom: 1px solid #c9c9c9;
  width: 100%;
  padding-bottom: 7px;
}
.order_contact_info_text {
  padding-left: 5%;
  margin-top: 10px;
  font-size: 17px;
}
.order_contact_info_text span {
  color: #898989;
  display: inline-block;
  width: 31%;
}
.back_order_list {
  width: 110px;
  height: 35px;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 50px;
  line-height: 35px;
  background-color: #4d8be6;
  text-align: center;
  color: #fff;
  font-size: 15px;
}
table thead tr {
  background-color: #e4e2e2;
  height: 45px;
}
table tbody tr {
  height: 45px;
}
table thead tr th {
  font-size: 17px;
  color: #898989;
  text-align: center;
  font-weight: normal;
}
table tbody tr td {
  font-size: 17px;
  color: #898989;
  text-align: center;
}
table tbody tr {
  border-bottom: 1px solid #ededed;
}
.receiver_money {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/customer/p_center/orderDetail.vue